import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";
import { useDesignTokens } from "../../context/ThemeContext";

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  const tokens = useDesignTokens();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        padding: "20px",
        textAlign: "center",
      }}
    >
      <h1 style={{ color: tokens.error, marginBottom: "16px" }}>
        Ocorreu um erro
      </h1>

      <p style={{ marginBottom: "24px", color: tokens.textSecondary }}>
        {error?.message || "Algo correu mal. Por favor, tente novamente."}
      </p>

      <button
        onClick={resetErrorBoundary}
        style={{
          padding: "12px 24px",
          backgroundColor: tokens.primary,
          color: "#fff",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer",
          fontWeight: "bold",
        }}
      >
        Tentar novamente
      </button>
    </div>
  );
};

const ErrorBoundary = ({ children }) => {
  return (
    <ReactErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={(error, info) => {
        console.error("ErrorBoundary caught an error:", error, info);
      }}
    >
      {children}
    </ReactErrorBoundary>
  );
};

export default ErrorBoundary;
